import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Endpoints`}</h2>
    <p>{`If you want to see these endpoints in action before getting started, you can use our `}<a parentName="p" {...{
        "href": "https://developers.giphy.com/explorer/"
      }}>{`API Explorer`}</a>{` to input sample queries and view the live responses!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      